import { render, staticRenderFns } from "./ChangedLogs.vue?vue&type=template&id=d0e07e6a"
import script from "./ChangedLogs.vue?vue&type=script&lang=js"
export * from "./ChangedLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports